import * as React from 'react';
export interface IFormProps {
    className?: string,
    onInvalidSubmit?: () => void
    onValidSubmit?: () => void;
    onSubmit?: () => void;
    disableOnEnter?: boolean;
}
export interface IFormState {
    submited: boolean,
    changed: { [name: string]: boolean }
}
export class Form extends React.Component<IFormProps, IFormState> {
    public formEl: any;
    public state = {
        submited: false,
        changed: {}
    }
    public isInvalid(element: HTMLFormElement, elements: HTMLFormElement[]) {
        const elementsName = elements.filter(e => e.name === element.name)
        let elementValid;
        if (elementsName.length >= 2) {
            elementValid = elementsName.some(nameElement => nameElement.validity.valid)
        } else {
            elementValid = element.validity.valid
        }
        return !elementValid && this.state.changed[element.name] || !elementValid && this.state.submited
    }
    public validateElement(element, parent, elements) {
        if (this.isInvalid(element, elements)) {
            parent.className = `${parent.className}${!parent.className.includes("text-danger") ? " text-danger" : ""}`
            element.className = `${element.className}${!element.className.includes("is-invalid") ? " is-invalid" : ""}`
            return false;
        } else {
            if (element.dataset.invalid === "true") {
                return true;
            }
            this.removeErrors(element, parent)
            return true;
        }
    }
    public removeErrors(element, parent) {
        element.className = element.className.replace(new RegExp('is-invalid', 'g'), '')
        parent.className = parent.className.replace(new RegExp('text-danger', 'g'), '')
    }
    public validate = () => {
        const form: HTMLFormElement = this.formEl;
        const elements: Element[] = Array.from(form);
        const validates = elements.map((element) => this.validateElement(element, element.parentElement, elements))
        return validates.reduce((valid, value) => valid && value, true);
    }
    public submitHandler = (event) => {
        event.preventDefault();
        if (this.props.onSubmit) {
            this.props.onSubmit();
        }
        this.setState({ submited: true }, () => {
            if (this.validate() && this.props.onValidSubmit) {
                this.props.onValidSubmit();
            } else if (this.props.onInvalidSubmit) {
                this.props.onInvalidSubmit();
            }
        });
    }
    public onChange = (event) => {
        event.preventDefault();
        if (event.target && event.target.name) {
            const elementName = event.target.name
            this.setState((state) => {
                const newState = { ...state };
                newState.changed[elementName] = true
                return newState;
            }, () => {
                this.validate();
            });
        }
    }
    public onKeyPress = (e) => {
        if (this.props.disableOnEnter === true && e.which === 13) {
            e.preventDefault()
        }
    }

    public render() {
        return (
            <form onKeyPress={this.onKeyPress} ref={form => this.formEl = form} onBlur={this.onChange} onChange={this.onChange} onSubmit={this.submitHandler} className="form" noValidate={true}>
                {this.props.children}
            </form>
        );
    }
}
